'use client';

import { motion } from 'framer-motion';
import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  align?: 'start' | 'center';
};

export function HeroEntrance({ children, align = 'start' }: Props) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: align === 'center' ? 'center' : 'flex-start',
      }}
    >
      {children}
    </motion.div>
  );
}
